import * as axios from 'axios';
export const submitEnquery = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-submit-enquery`;
    return axios.post(url, model).then((res) => {
        return res.data;
    })
};
